import { render } from "./ComparisonFilter.vue?vue&type=template&id=a3c85aaa&scoped=true"
import script from "./ComparisonFilter.vue?vue&type=script&lang=js"
export * from "./ComparisonFilter.vue?vue&type=script&lang=js"

import "./ComparisonFilter.vue?vue&type=style&index=0&id=a3c85aaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c85aaa"]])

export default __exports__